<div class="container" *ngIf="!viewPackage?.System_status">
    <div class="row">
        <div class="col-6">
            <h1>System</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-center" *ngFor="let sys of SystemItems">
            <div class="shadow  p-3 mt-3 box-package" (click)="view(sys)">
                <div class="box-image text-center ">
                    <img [src]="sys.System_logo">
                </div>
                <p><b>{{sys.System_name}}</b></p>
            </div>
        </div>
    </div>
    <br><br><br>
</div>

